import CountryListStore from './country.list';

export const dropdownStores = {
  country: CountryListStore,
};
